import { selectAppConfig } from "../../app/selectors";

export const selectCarYear = state => selectAppConfig(state).car_year;
